import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initGoogleAnalytics, subscribeConsentUpdates, trackPageView } from '@/analytics/ga'

/**
 * Loads GA4 after consent, sends SPA virtual page_views on route changes.
 * Keep alongside existing session "analytics" (heatmap) — different systems.
 */
export function useGoogleAnalyticsPageViews() {
  const location = useLocation()

  useEffect(() => {
    subscribeConsentUpdates()
    initGoogleAnalytics()
  }, [])

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search || ''}`)
  }, [location.pathname, location.search])
}
